"use client"

import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Spin, SpinProps } from "antd";
import Image, { ImageProps } from "next/image"
import { useEffect, useRef, useState } from "react";

const NextImage = ({ spin, hiddenSpin, ...props }: ImageProps & { spin?: SpinProps, hiddenSpin?: boolean }) => {
  const [loading, setLoading] = useState<boolean>(false)
  const refTimeout = useRef<any>(null)

  useEffect(() => {
    if (!!props.src) {
      if (refTimeout.current) {
        clearTimeout(refTimeout.current)
        refTimeout.current = null
      }
      refTimeout.current = setTimeout(() => {
        refTimeout.current = null
        setLoading(true)
      }, 200)
    }
  }, [props.src])

  if (!props.src) return null;

  const content = (
    <Image
      {...props}
      src={(props.src as string).replace('mpodx.shop', 'static.mpodx.com/old-image')}
      onLoad={() => {
        if (refTimeout.current) {
          clearTimeout(refTimeout.current)
          refTimeout.current = null
        } else {
          setLoading(false)
        }
      }}
      onError={() => {
        if (refTimeout.current) {
          clearTimeout(refTimeout.current)
          refTimeout.current = null
        } else {
          setLoading(false)
        }
      }}
    />
  )

  if (!!hiddenSpin) {
    return content
  }

  return (
    <Spin {...spin} spinning={loading} indicator={<FontAwesomeIcon size="3x" spin spinPulse spinReverse icon={faSpinner} />}>
      {content}
    </Spin>
  )
}

export default NextImage